import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, TextArea } from '@gasbuddy/react-components';
import RowWithLabel from '../row-with-label';

import styles from './styles.css';

class InputWithLabel extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    isOptional: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    isInvalid: PropTypes.bool,
    textArea: PropTypes.bool,
    maxLength: PropTypes.number,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    value: '',
    placeholder: '',
    required: false,
    isOptional: false,
    disabled: false,
    onChange: () => {},
    error: 'Invalid input',
    isInvalid: false,
    textArea: false,
    maxLength: null,
    onBlur: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  handleOnInputChange = (e) => {
    e.preventDefault();
    const { value } = e.currentTarget;
    const { onChange } = this.props;
    this.setState(() => ({ value }));
    onChange(e);
  }

  componentDidUpdate = (prevProps) => {
    const { value } = this.props;
    if (value !== prevProps.value) {
      this.setState(() => ({ value }));
    }
  }

  getTextBox = () => {
    const { placeholder, disabled, textArea, error, isInvalid, maxLength, onBlur } = this.props;
    const { value } = this.state;
    if (textArea) {
      return (
        <>
          <TextArea
            size="sm"
            onChange={this.handleOnInputChange}
            value={value}
            disabled={disabled}
            error={isInvalid ? error : null}
            placeholder={placeholder}
            onBlur={onBlur}
            maxLength={maxLength}
            rows={3}
            autoHeight
          />
          {isInvalid ? <span className={styles.inputError}>{error}</span> : null}
        </>

      );
    }

    return (
      <InputGroup.Input
        size="sm"
        onChange={this.handleOnInputChange}
        value={value}
        disabled={disabled}
        error={isInvalid ? error : null}
        placeholder={placeholder}
        maxLength={maxLength}
        onBlur={onBlur}
      />
    );
  }

  render = () => {
    const { label, className, required, isOptional } = this.props;
    return (
      <RowWithLabel
        label={label}
        required={required}
      >
        <InputGroup
          className={className}
        >
          {this.getTextBox()}
        </InputGroup>
        {isOptional && <div style={{ fontSize: '12px', fonWeight: '300' }}>Optional</div>}
      </RowWithLabel>
    );
  }
}

export default InputWithLabel;
